module.exports = __webpack_public_path__ + "img/guide.322a0222.jpg";